import SubscribersPage from "./SubscribersPage";

export default SubscribersPage;